import React from 'react';
import { motion } from 'framer-motion';
import { Phone, MessageCircle } from 'lucide-react';
export function Contact() {
  return <section id="contact" className="py-24 bg-background" data-id="element-43">
      <div className="max-w-4xl mx-auto px-6" data-id="element-44">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-surface p-8 md:p-12 rounded-[2.5rem] border border-border text-center" data-id="element-45">
          <h2 className="text-3xl md:text-4xl font-semibold mb-6" data-id="element-46">
            Потрібна бухгалтерська допомога?
          </h2>
          <p className="text-secondary mb-10 text-lg max-w-2xl mx-auto" data-id="element-47">
            Залиште дзвінок або напишіть — разом розберемось у вашій ситуації та
            знайдемо рішення.
          </p>

          <div className="flex flex-col items-center justify-center gap-2 mb-10" data-id="element-48">
            <div className="text-xl font-medium text-primary" data-id="element-49">Вікторія</div>
            <a href="tel:+380632562477" className="text-2xl font-semibold text-primary hover:opacity-80 transition-opacity" data-id="element-50">
              +38 (063) 256-24-77
            </a>
          </div>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-51">
            <a href="tel:+380632562477" className="w-full sm:w-auto px-8 py-4 bg-primary text-background rounded-full font-medium flex items-center justify-center gap-2 hover:opacity-90 transition-opacity shadow-lg" data-id="element-52">
              <Phone size={20} data-id="element-53" />
              Зателефонувати
            </a>
            <a href="https://t.me/+380632562477" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto px-8 py-4 bg-surface text-primary border border-border rounded-full font-medium flex items-center justify-center gap-2 hover:bg-border/50 transition-colors shadow-sm" data-id="element-54">
              <MessageCircle size={20} data-id="element-55" />
              Написати в Telegram
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}